<template>
  <div class="pa-2">

    <template v-if="item.editable">

      <v-row class="align-center">
        <v-col md="3">
          Name:
        </v-col>
        <v-col md="9">
          <c-input :value.sync="item.name" class="crx-box-input">
          </c-input>
        </v-col>
      </v-row>

      <v-row class="align-center">
        <v-col md="3">
          Type:
        </v-col>
        <v-col md="9">
          <v-select hide-details :items="types" v-model="item._schema._type" solo class="crx-box-input"></v-select>
        </v-col>
      </v-row>

      <v-row class="align-center">
        <v-col md="3">
          Not Null:
        </v-col>
        <v-col md="9">
          <v-checkbox v-model="item._schema._not_null" hide-details class="ma-0"></v-checkbox>
        </v-col>
      </v-row>

      <!-- DEFAULTS -->
      <v-row v-if="item._schema._type === 'boolean'" class="align-center">
        <v-col md="3">
          Default:
        </v-col>
        <v-col md="9">
          <v-select hide-details :items="booleanDefaultValues" v-model="item._schema._default" solo class="crx-box-input"></v-select>
        </v-col>
      </v-row>

      <v-row v-if="item._schema._type === 'object'" class="align-center">
        <v-col md="3">
          Default:
        </v-col>
        <v-col md="9">
          <c-input :value.sync="item._schema._default" class="crx-box-input">
          </c-input>
        </v-col>
      </v-row>
      <!-- DEFAULTS -->

    </template>

    <template v-else>
      {{ item.name }}
      <v-icon small>mdi-lock</v-icon>
      <div class="pa-2 caption">
        This column cannot be edited
      </div>
    </template>

    <div class="caption mt-4">
      <!-- <json-viewer :item="item"></json-viewer> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: null
  },
  data () {
    return {
      types: ['boolean', 'object', 'array', 'string']
    }
  },
  computed: {
    booleanDefaultValues () {
      return ['true', 'false']
    }
  }
}
</script>